module.exports = __webpack_public_path__ + "img/NoAddressSelected.d914720d.svg";